import { render } from "./ClubEvents.vue?vue&type=template&id=8e0b4f1a&ts=true"
import script from "./ClubEvents.vue?vue&type=script&lang=ts"
export * from "./ClubEvents.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__